import { StatefulLoader } from '@mauriceguest/guest'
import { AbstractTariffLoader } from '../../generated'

export class TariffLoader extends AbstractTariffLoader {}

/** @constructor @extends {TariffLoader} @suppress {checkTypes} */ function _TariffLoader() {}
AbstractTariffLoader.__implement(TariffLoader, StatefulLoader,
 _TariffLoader.prototype = /** @type {!TariffLoader} */ ({
  async fetchTariff() {
   const{
    asITariffLoader: { setState },
    // asIStateful:{setState},
    asIStatefulLoader:{fetchJSON},props:{HOST, bike_id},
   }=this
   const bikes = (await fetchJSON(`${HOST}/api/moto-park?bike_id=${bike_id}`, {
    credentials: 'include',
   })) || ''
   /** @type {ru.hulkmoto.IBikeDocument} */
   const bike = bikes[0] || null
   if (bike) {
    setState({
     twelveHourDiscount: bike['twelveHourDiscount'],
     dailyDiscount: bike['dailyDiscount'],
     dailyPrice: bike.dailyPrice,
     fiveHourPrice: bike.fiveHourPrice,
     nightlyPrice: bike.nightlyPrice,
     twelveHourPrice: bike.twelveHourPrice,
     inventoryState: bike['inventoryState'],
    })
   }
  },
 }),
)
